import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable, throwError, of } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { UiService } from '@services/ui.service';
import { AuthService } from '@services/auth.service';

@Injectable()
export class HelpResolver implements Resolve<boolean> {
    constructor(
        private uiSrv: UiService,
        private authSrv: AuthService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {

        if(this.authSrv.isAuth()) {
            return of(true);
        }

        const decodedToken = this.authSrv.getDecodedToken();
        if(decodedToken) {
            if(decodedToken.upd_pwd_req) {
                return of(false);
            }

            this.uiSrv.routeLoadingStateChanged.next(true);
            return this.authSrv.refreshToken()
            .pipe(
                map(() => {
                    this.uiSrv.routeLoadingStateChanged.next(false);
                    return true;
                }),
                catchError((error) => {
                    this.uiSrv.routeLoadingStateChanged.next(false);
                    return throwError(error);
                })
            );
        }

        return of(false);
    }
}
